module.exports = __webpack_public_path__ + "static/media/carousel-2.fc402dd2.jpg";